import { Link } from 'react-router-dom';
import './Stats.css';
import PlayerStats from '../../components/PlayerStats/PlayerStats';
import Button from '../../components/Button/Button';
import { handleHomeClick, playSound } from '../../utils/utils';

const Stats = (props) => {
  window.scrollTo(0, 0);

  const { playerNamesState } = props;

  const playersStats = playerNamesState.map((player) => {
    const { name, average, totalWins, id } = player;

    return (
      <PlayerStats
        key={id}
        name={name}
        average={Math.round(average * 10) / 10}
        totalWins={totalWins}
        id={id}
      />
    );
  });

  const handleGoBackClick = () => {
    playSound('/sounds/menu-select-3.mp3');
  };

  return (
    <div className="playersStats">
      <Link to="/">
        <div className="header">
          <Button
            title="home"
            type="smallSquare home"
            handleClick={handleHomeClick}
          />
        </div>
      </Link>
      <p className="multiPlayerTitle">player stats</p>
      <div className="playerStatsHeader">
        <div className="playerName"></div>
        <div className="playerAverage">Avg. Roll</div>
        <div className="playerTotalWins">Wins</div>
      </div>

      <div className="multiPlayerStats">{playersStats}</div>
      <div className="goBack">
        <Link to="/multi/pre-roll">
          <Button
            title="Go back"
            type="smallSquare goBack"
            handleClick={handleGoBackClick}
          />
        </Link>
      </div>
    </div>
  );
};

export default Stats;
